import React from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, useFormikContext } from 'formik';
import { Input } from 'syngenta-digital-cropwise-react-ui-kit';

const FormulationInput = ({ fieldValue }) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const formatPercent = e => {
    const normalized = e.target.value.trim().replace(/%$/, '');
    if (!/^-?(?:\d+(?:\.\d+)?|\.\d+)$/.test(normalized)) return;
    const percent = Number(normalized);
    setFieldValue(`formulation.${fieldValue}`, `${percent.toFixed(2)}%`);
  };

  return (
    <>
      <div className="text-neutral-60">{fieldValue}</div>
      <Input
        placeholder="0%"
        name={`formulation.${fieldValue}`}
        value={values.formulation?.[fieldValue]}
        onChange={e => {
          setFieldValue(`formulation.${fieldValue}`, e.target.value);
        }}
        onBlur={e => {
          setFieldTouched(`formulation.${fieldValue}`, true);
          formatPercent(e);
        }}
      />
      <ErrorMessage
        name={`formulation.${fieldValue}`}
        component="div"
        className="text-remove text-wrap"
      />
    </>
  );
};

FormulationInput.propTypes = {
  fieldValue: PropTypes.string.isRequired
};

export default FormulationInput;
